"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitRegisterForm = exports.getPostFormData = void 0;
var react_1 = __importDefault(require("react"));
var react_intl_1 = require("react-intl");
var newsletterSubscribeTexts = react_intl_1.defineMessages({
    errorEmailApi: {
        id: 'nlForm.errorEmailApi',
    },
});
var getDeviceType = function (config) {
    var _a, _b, _c, _d;
    var width = window.innerWidth;
    if (width <= parseInt((_b = (_a = config === null || config === void 0 ? void 0 : config.mediaBreakpoints) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.tabletMinWidth, 10)) {
        return 'mob';
    }
    if (width <= parseInt((_d = (_c = config === null || config === void 0 ? void 0 : config.mediaBreakpoints) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.desktopMinWidth, 10)) {
        return 'tab';
    }
    return 'web';
};
var getQueryParam = function (parameterName) {
    if (typeof window !== 'undefined') {
        var queryParams = new URLSearchParams(window.location.search);
        return queryParams.get(parameterName);
    }
    return null;
};
var getPostFormData = function (areaKey, emailAddress, 
// eslint-disable-next-line @typescript-eslint/no-shadow
deviceType, locale, firstName, lastName) {
    return ({
        emailAddress: emailAddress,
        areaKey: getQueryParam('areaKey') || areaKey,
        contextUri: window.location.pathname === '/' ? '/storefront' : window.location.pathname,
        deviceType: deviceType,
        locale: locale,
        firstName: firstName,
        lastName: lastName,
    });
};
exports.getPostFormData = getPostFormData;
var submitRegisterForm = function (setState, intl, config, areaKey) { return __awaiter(void 0, void 0, void 0, function () {
    var setPage, pushNotification, salutationField, firstNameField, lastNameField, emailField, postData, myHeaders;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                setPage = setState.setPage, pushNotification = setState.pushNotification;
                salutationField = document.getElementById('newsletterSalutation');
                firstNameField = document.getElementById('newsletterFirstName');
                lastNameField = document.getElementById('newsletterLastName');
                emailField = document.getElementById('newsletterEmail');
                postData = exports.getPostFormData(areaKey, emailField.value, getDeviceType(config), intl.locale.substr(0, 2), firstNameField.value, lastNameField.value);
                if (salutationField.value) {
                    postData.salutation = salutationField.value;
                }
                myHeaders = new Headers();
                myHeaders.append('Content-Type', 'application/json');
                return [4 /*yield*/, fetch(((_b = (_a = config === null || config === void 0 ? void 0 : config.apiAgnitasUrl) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.url) + "/subscribe", {
                        headers: myHeaders,
                        method: 'POST',
                        body: JSON.stringify(postData),
                    })
                        .then(function (response) {
                        if (!response.ok) {
                            throw new Error();
                        }
                        return response.json();
                    })
                        .then(function (_a) {
                        var _b, _c;
                        var resultType = _a.resultType;
                        if (resultType === 'ALREADY_SUBSCRIBED') {
                            setPage(4);
                        }
                        else if ((_c = (_b = config === null || config === void 0 ? void 0 : config.apiAgnitasUrl) === null || _b === void 0 ? void 0 : _b.values) === null || _c === void 0 ? void 0 : _c.useDOI) {
                            setPage(2);
                        }
                        else {
                            setPage(3);
                        }
                    })
                        .catch(function () {
                        var errorElement = react_1.default.createElement(react_1.default.Fragment, null, intl.formatMessage(newsletterSubscribeTexts.errorEmailApi));
                        pushNotification({ level: 'warning', content: errorElement, autoClose: 4000 });
                    })];
            case 1:
                _c.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.submitRegisterForm = submitRegisterForm;
//# sourceMappingURL=submitRegisterForm.js.map